import type { Token } from "../../../formula/formulaToken";
import { expressionToTokens } from "../../../formula/expressionToTokens";

const varCodes = (tokens: Token[]): Set<string> =>
  new Set(tokens.filter((t) => t.kind === "var").map((t) => t.value));

export function computeRemovedCodes(
  savedExpression: string,
  currentTokens: Token[],
): Set<string> {
  const saved = varCodes(expressionToTokens(savedExpression) ?? []);
  const current = varCodes(currentTokens);
  return new Set([...saved].filter((code) => !current.has(code)));
}
